@if (_pageCount > 1) {
  <div class="pagination-container">
    <button class="btn btn--info"
      (click)="jumpToPage(currentPage - 1)"
      [disabled]="currentPage === 1">
      {{ 'COMMON.PREVIOUS_PAGE' | translate }}
    </button>
    <mat-select [(ngModel)]="currentPage" (ngModelChange)="jumpToPage($event)">
      @for (page of pages; track page) {
        <mat-option [value]="page">
          <span translate [translateParams]="{page: page, pageCount: _pageCount}">COMMON.PAGE</span>
        </mat-option>
      }
    </mat-select>
    <button class="btn btn--info"
      (click)="jumpToPage(currentPage + 1)"
      [disabled]="currentPage >= _pageCount">
      {{ 'COMMON.NEXT_PAGE' | translate }}
    </button>
  </div>
}
